import { useQuery } from '@tanstack/react-query'
import { nativeLocation, type GeoPoint } from './nativeBridge'

/** Координаты — до шести знаков: это около 10 см, точнее не нужно. */
const round = (n: number) => Math.round(n * 1e6) / 1e6

/**
 * Где сейчас телефон. В нашем Flutter-приложении — GPS оболочки (обработчик
 * `getLocation`), иначе — геолокация браузера. null — доступа не дали или
 * точка не пришла за 10 секунд.
 */
export async function currentLocation(): Promise<{ lat: number; lng: number } | null> {
  const native = await nativeLocation()
  if (native) return { lat: round(native.latitude), lng: round(native.longitude) }
  const geo = navigator.geolocation as Geolocation | undefined
  if (!geo) return null
  const point = await new Promise<GeoPoint | null>((resolve) => {
    geo.getCurrentPosition(
      (position) => {
        resolve({ latitude: position.coords.latitude, longitude: position.coords.longitude })
      },
      () => {
        resolve(null)
      },
      { enableHighAccuracy: true, timeout: 10_000, maximumAge: 60_000 },
    )
  })
  return point ? { lat: round(point.latitude), lng: round(point.longitude) } : null
}

/**
 * Где телефон — один раз на несколько минут для всех экранов: оформление и
 * карта аптек не спрашивают геолокацию дважды. Отказ не повторяем — нет точки,
 * нет и расстояний.
 */
export function useCurrentLocation(enabled = true) {
  return useQuery({
    queryKey: ['current-location'],
    queryFn: currentLocation,
    enabled,
    staleTime: 5 * 60_000,
    retry: false,
  })
}
